module.exports = __webpack_public_path__ + "img/_box_contact.7b688525.svg";